import React from 'react';
import EquipmentSection from './EquipmentSection';
import { useEquipmentLabels } from '../hooks/useEquipment';

export default function EquipmentVideo({ video }) {
  const label = useEquipmentLabels();
  if (!video) return null;
  return <EquipmentSection eyebrow={video.eyebrow} title={video.title}>
    <p>{video.description}</p>
    <video key={video.src} className="equipment-video" controls playsInline preload="none" poster={video.poster} aria-label={video.title}>
      <source src={video.src} type="video/mp4" />
      {label('videoFallback')}
    </video>
  </EquipmentSection>;
}
